import type { SpotType } from "~/types/listings";

export const SPOT_TYPE_LABELS: Record<SpotType, string> = {
  outdoor: "Driveway",
  garage: "Garage",
  covered: "Carport",
  indoor: "Indoor",
};
